import React from "react";
import { Box, Container, makeStyles, Typography } from "@material-ui/core";
import Page from "src/components/Page";
import Form from "./Form";
import actions from "src/duck/global/actions";
import { connect } from "react-redux";
import { apiEndpoints, apiPutRequest } from "src/utils/api/api";
import { useNavigate } from "react-router-dom";
import { buildPassChangePayload } from "src/utils/utils";
import { kmMessages } from "src/constant/Messages";
import KmPageTitle from "src/components/layout/KmPageTitle"

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  title: {
    marginLeft: theme.spacing(3),
  },
}));

const MyAccountPasswordForm = ({
  globalData,
  enableGlobalLoader,
  disableGlobalLoader,
  displaySnackbar,
  ...rest
}) => {
  const classes = useStyles();
  const navigate = useNavigate();

  let pageTitle = "Zmiana hasła";

  const onSubmit = (values) => {
    enableGlobalLoader();
    if (globalData?.currentUser?.currentUserData?.username) {
      apiPutRequest(
        apiEndpoints.passwordChangeLogged.path,
        buildPassChangePayload(
          globalData.currentUser.currentUserData.username,
          values.cpassword,
          null,
          values.password1,
          values.password2
        ),
        true
      )
        .then((data) => {
          disableGlobalLoader();
          displaySnackbar({
            isOpen: true,
            severity: "success",
            autoHideDuration: 3000,
            message: kmMessages.info.password_reset.passchangesuccess,
          });
          navigate("/mojekonto");
        })
        .catch((error) => {
          disableGlobalLoader();
          if (error.response) {
            if (error.response.status === 400 && error.response.data) {
              if (error.response.data.code === "ERROR_PASSWORDS_NOT_MATCH") {
                displaySnackbar({
                  isOpen: true,
                  severity: "error",
                  autoHideDuration: 8000,
                  message: kmMessages.error.password_reset.passnotmatch,
                });
              } else if (
                error.response.data.code === "ERROR_INVALID_CURRENT_PASSWORD"
              ) {
                displaySnackbar({
                  isOpen: true,
                  severity: "error",
                  autoHideDuration: 8000,
                  message: kmMessages.error.password_reset.passcurrwrong,
                });
              } else if (
                error.response.data.code ===
                "ERROR_PASSWORD_NOT_STRENGTH_ENOUGH"
              ) {
                displaySnackbar({
                  isOpen: true,
                  severity: "error",
                  autoHideDuration: 10000,
                  message: kmMessages.error.password_reset.passstrength,
                });
              } else if (
                error.response.data.code === "ERROR_PASSWORD_USED_IN_PAST"
              ) {
                displaySnackbar({
                  isOpen: true,
                  severity: "error",
                  autoHideDuration: 8000,
                  message: kmMessages.error.password_reset.passuniqinpast.replaceAll(
                    "{count}",
                    error.response.data.description
                  ),
                });
              } else {
                displaySnackbar({
                  isOpen: true,
                  severity: "error",
                  autoHideDuration: 8000,
                  message: kmMessages.error.password_reset.unexpasschange,
                });
              }
            } else {
              displaySnackbar({
                isOpen: true,
                severity: "error",
                autoHideDuration: 8000,
                message: kmMessages.error.password_reset.unexpasschange,
              });
            }
          } else {
            displaySnackbar({
              isOpen: true,
              severity: "error",
              autoHideDuration: 8000,
              message: kmMessages.error.password_reset.unexpasschange,
            });
          }
        });
    }
  };

  return (
    <Page className={classes.root} title={pageTitle}>
      <KmPageTitle>
        {pageTitle}
      </KmPageTitle>

      <Container maxWidth={false}>
        <Box mt={3}>
          <Form onSubmit={onSubmit} />
        </Box>
      </Container>
    </Page>
  );
};

const mapStateToProps = (state) => ({
  globalData: state.globalData,
});

const mapDispatchToProps = (dispatch) => ({
  enableGlobalLoader: () => dispatch(actions.enableGlobalLoader()),
  disableGlobalLoader: () => dispatch(actions.disableGlobalLoader()),
  displaySnackbar: (snackBarParameters) =>
    dispatch(actions.displaySnackbar(snackBarParameters)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MyAccountPasswordForm);
